import React from 'react';
import { Node } from '@uncinc/react-drupal-core';

import './style.scss';

const ParagraphColleague = ({ entity, className }) => {
  return (
    <div className={`Paragraph ParagraphColleague ${className}`}>
      <h2>{entity.getIn(['field_title', 0, 'value'], 'Dit wordt jouw nieuwe collega')}</h2>

      {entity.get('field_colleague').size > 0
        && <Node viewMode="paragraph" entity={entity.getIn(['field_colleague', 0, 'entity'])} />}

    </div>
  );
};

export default ParagraphColleague;
